import { RouteConfig } from 'vue-router';
import { PermissionTypeEnum } from '../Api';
import ReportedChecklists from './pages/ReportedChecklists.vue';

export default [
    {
        path: '/:tenantId/reported-checklists',
        name: 'ReportedChecklists',
        component: ReportedChecklists,
        props: (route) => ({ tenantId: route.params.tenantId }),
        meta: {
            permissions: [PermissionTypeEnum.PerformAudit, PermissionTypeEnum.Response, PermissionTypeEnum.MistakeCorrection],
            checkLicence: true,
            title: 'menu.reportedChecklists',
        },
    },
] as RouteConfig[];
